// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zu3b","delete":"styles_delete__-5UHv","update":"styles_update__34w-S","add":"styles_add__1NQTF"};